import React, { useEffect, useState } from "react";
import $ from "jquery";
import { BrowserRouter as Router } from "react-router-dom";
import { LinkProvider } from './LinkProvider';
import { images } from "./imagesToLoad";
import Header from "./components/Header";
import AnimatedRoutes from "./AnimatedRoutes";
import Lenis from '@studio-freight/lenis'

function App() {
  
  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.1,
      smoothWheel: true,
      smoothTouch: false,
    })

    function raf(time) {
      lenis.raf(time)
      requestAnimationFrame(raf)
    }
    requestAnimationFrame(raf)

    return () => lenis.destroy()
  }, [])


  const [isLoading, setIsLoading] = useState(true);

  const loadImage = (image) => {
    return new Promise((resolve, reject) => {
      const newImage = new Image();
      newImage.src = image;
      newImage.onload = () => resolve(image);
      newImage.onerror = (err) => reject(err);
    });
  };

  useEffect(() => {
    if (isLoading) $("body").addClass("ovf-hidden");
    Promise.all(images.map((image) => loadImage(image)))
      .then(() => setIsLoading(false))
      .catch((err) => {
        console.log("Failed to load images", err);
        setIsLoading(false);
      });
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (!isLoading) {
      $("body").removeClass("ovf-hidden");
      $("#loader").addClass("hide");
    }
  }, [isLoading]);
   

  return (
    <Router>
      <LinkProvider>
        <Header />
          <AnimatedRoutes />     
      </LinkProvider>
    </Router>
  );
}

export default App;
